import ObjectSelectionDesktopView from './desktop/ObjectSelection.desktop.view';
import type ObjectSelectionProperties from './ObjectSelection.properties.ts';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';

export default function ObjectSelectionView(props: ObjectSelectionProperties) {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <ObjectSelectionDesktopView {...props} />}</>;
}
